import React from "react";
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import RadialSeparators from "./RadialSeparators";

const images = {
  complaints: "complaints.svg",
  consulting_and_reviewing_documents: "consulting_and_reviewing_documents.svg",
  contract_writing: "contract_writing.svg",
  international: "international.svg",
  petition: "petition.svg",
  advocacy_acceptation: "advocacy_acceptation.svg",
  dedicated_services: "dedicated_services.svg",
  call: "dedicated_services.svg",
};

const Step = ({ step, isFinding, rootType }) => {
  function calcStep() {
    return step * 15 + 35;
  }

  const percent = calcStep();
  return (
    <div className="step-holder">
      <img
        src={require(`./../../../images/home/singlePages/${images?.[rootType]}`)}
        alt={rootType}
      />
      <div className="progressbar-holder">
        <CircularProgressbarWithChildren
          value={isFinding ? 100 : percent}
          // text={`${isFinding ? 100 : percent}%`}
          strokeWidth={3}
          styles={buildStyles({
            strokeLinecap: "butt",
          })}
        >
          <RadialSeparators percent={percent} />
        </CircularProgressbarWithChildren>
      </div>
    </div>
  );
};

export default Step;
